<template>
  <div class="content-container">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      label-width="100px"
    >
      <div>
        <el-form-item label="账单日期">
          <el-date-picker
            v-model="formInline.billDate"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
      </div>
      <div>
        <agentVendorShop @select="selectHandler" />

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmitPre"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-download"
            @click="handleDownload"
            >下载</el-button
          >
        </el-form-item>

        <el-form-item v-if="userType === 'admin'">
          <el-button type="danger" icon="el-icon-search" @click="onSubmitVipPre"
            >查询VIP卡账单</el-button
          >
          <el-button
            type="danger"
            icon="el-icon-download"
            @click="handleDownloadVip"
            >下载VIP卡账单</el-button
          >
        </el-form-item>
      </div>
    </el-form>
    <div style="padding: 0 100px;display:flex; justify-content: space-between ">
      <span class="sp1"
        >总收入：<span class="sp2">{{ sumbill.payment_amount }}元</span></span
      >
      <span class="sp1"
        >总支付笔数：<span class="sp2"
          >{{ sumbill.payment_count }}笔</span
        ></span
      >
      <span class="sp1"
        >总退款：<span class="sp2">{{ sumbill.refund_amount }}元</span></span
      >
      <span class="sp1"
        >总退款笔数：<span class="sp2">{{ sumbill.refund_count }}笔</span></span
      >
      <span class="sp1"
        >全量总计金额：<span class="sp2"
          >{{ sumbill.total_amount }}元</span
        ></span
      >
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="date" label="日期">
        <template slot-scope="scope">
          <div v-html="scope.row.date"></div>
        </template>
      </el-table-column>
      <el-table-column prop="agentName" label="总代"></el-table-column>
      <el-table-column prop="vendorName" label="加盟商"></el-table-column>
      <el-table-column prop="shopName" label="门店"></el-table-column>
      <el-table-column prop="paymentAmount" label="收入">
        <template slot-scope="scope">
          <span>{{ scope.row.paymentAmount }}元</span>
        </template>
      </el-table-column>
      <el-table-column prop="paymentCount" label="支付笔数">
        <template slot-scope="scope">
          <span>{{ scope.row.paymentCount }}笔</span>
        </template>
      </el-table-column>
      <el-table-column prop="refundAmount" label="退款">
        <template slot-scope="scope">
          <span>{{ scope.row.refundAmount }}元</span>
        </template>
      </el-table-column>
      <el-table-column prop="refundCount" label="退款笔数">
        <template slot-scope="scope">
          <span>{{ scope.row.refundCount }}笔</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalAmount" label="总计金额">
        <template slot-scope="scope">
          <span>{{ scope.row.totalAmount }}元</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>
  </div>
</template>

<script>
//import { mapGetters } from "vuex";
import moment from "moment";
import agentVendorShop from "@/components/layout/agentVendorShop";
export default {
  components: {
    agentVendorShop
  },
  data() {
    return {
      formInline: {
        billDate: [moment().subtract(1, "days"), moment()],
        agentid: "",
        vendorid: "",
        shopid: "",
        agentName: "",
        vendorName: "",
        shopName: ""
      },
      tableData: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      currentAction: "querybill",
      // vendorList: [],
      // shopList: [],
      // agentList: [],
      agentListForPrompt: [],
      vendorListForPrompt: [],
      shopListForPrompt: [],

      sumbill: {
        payment_amount: 0,
        payment_count: 0,
        refund_amount: 0,
        refund_count: 0,
        total_amount: 0
      },

      userType: this.$getUserType()
    };
  },

  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);
      this.formInline.agentid = x.selectedAgent.agentid;
      this.formInline.vendorid = x.selectedVendor.vendorid;
      this.formInline.shopid = x.selectedShop.shopid;
    },
    onSubmitPre() {
      this.page.currentPage = 1;
      this.onSubmit();
    },
    async onSubmit() {
      this.currentAction = "queryBill";
      let queryModel = {
        agentid: this.formInline.agentid,
        vendorid: this.formInline.vendorid,
        shopid: this.formInline.shopid,
        dateFrom: this.$ToDateString(this.formInline.billDate[0]),
        dateTo: this.$ToDateString(this.formInline.billDate[1]),
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      let result = await this.$axios(this.$urlMapping["查询账单"], {
        data: queryModel
      });
      console.log("查询账单", result.totalCount);
      this.tableData = result.data;
      this.page.total = result.totalCount;
      this.page.currentPage = result.pageNum;

      result = await this.$axios(this.$urlMapping["查询账单总和"], {
        data: queryModel
      });
      console.log("查询账单总和", result);

      this.sumbill = result;
    },
    onSubmitVipPre() {
      this.page.currentPage = 1;
      this.onSubmitVip();
    },

    async onSubmitVip() {
      this.currentAction = "queryVipBill";
      let queryModel = {
        agentid: this.formInline.agentid,
        vendorid: this.formInline.vendorid,
        dateFrom: this.$ToDateString(this.formInline.billDate[0]),
        dateTo: this.$ToDateString(this.formInline.billDate[1]),
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      let result = await this.$axios(this.$urlMapping["查询VIP卡账单"], {
        data: queryModel
      });

      this.tableData = result.data;
      this.page.total = result.totalCount;
      this.page.currentPage = result.pageNum;

      result = await this.$axios(this.$urlMapping["查询VIP卡账单总和"], {
        data: queryModel
      });
      console.log("查询VIP卡账单总和", result);
      this.sumbill = result;
    },

    handleCurrentChange(currentPage) {
      //console.log("currentPage=" + currentPage);
      //console.log(this.currentAction);
      this.page.currentPage = currentPage;
      if (this.currentAction == "queryBill") {
        this.onSubmit();
      } else if (this.currentAction == "queryVipBill") {
        this.onSubmitVip();
      }
    },

    handleDownload() {
      let queryModel = {
        agentid: this.formInline.agentid,
        vendorid: this.formInline.vendorid,
        shopid: this.formInline.shopid,
        dateFrom: this.$ToDateString(this.formInline.billDate[0]),
        dateTo: this.$ToDateString(this.formInline.billDate[1]),
        pageNum: 1,
        pageSize: 9999999
      };

      let t1 = moment(queryModel.dateFrom);
      let t2 = moment(queryModel.dateTo);
      let days = t2.diff(t1, "days");
      if (days < 0 || days > 92) {
        this.$notify.error({
          title: "错误",
          message: "时间跨度最多3个月"
        });

        return;
      }

      this.$download(this.$urlMapping["下载账单"], {
        data: queryModel
      }).then(result => {
        let fileName = "订单账单明细" + new Date().getTime();
        this.downloadCSV(result.data, fileName);
      });
    },

    handleDownloadVip() {
      let queryModel = {
        agentid: this.formInline.agentid,
        vendorid: this.formInline.vendorid,
        shopid: this.formInline.shopid,
        dateFrom: this.$ToDateString(this.formInline.billDate[0]),
        dateTo: this.$ToDateString(this.formInline.billDate[1]),
        pageNum: 1,
        pageSize: 9999999
      };

      let t1 = moment(queryModel.dateFrom);
      let t2 = moment(queryModel.dateTo);
      let days = t2.diff(t1, "days");
      if (days < 0 || days > 92) {
        this.$notify.error({
          title: "错误",
          message: "时间跨度最多3个月"
        });

        return;
      }
      console.log(this.$urlMapping["下载VIP卡账单"]);
      this.$download(this.$urlMapping["下载VIP卡账单"], {
        data: queryModel
      }).then(result => {
        let fileName = "Vip权益卡账单明细" + new Date().getTime();
        this.downloadCSV(result.data, fileName);
      });
    },

    downloadCSV(data, fileName) {
      var blob = new Blob([data], {
        type: "application/octet-stream;charset=utf-8"
      });
      var downloadElement = document.createElement("a");
      var href = window.URL.createObjectURL(blob); // 创建下载的链接
      downloadElement.href = href;
      downloadElement.download =
        typeof fileName !== "undefined"
          ? fileName + ".csv"
          : "账单明细" + new Date().getTime() + ".csv"; // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
      window.URL.revokeObjectURL(href); // 释放掉blob对象
    }

    // querySearchAgent(queryString, cb) {
    //   let results = queryString
    //     ? this.agentListForPrompt.filter(this.$createFilter(queryString))
    //     : this.agentListForPrompt;
    //   // 调用 callback 返回建议列表的数据
    //   cb(results);
    // },

    // querySearchVendor(queryString, cb) {
    //   let results = queryString
    //     ? this.vendorListForPrompt.filter(this.$createFilter(queryString))
    //     : this.vendorListForPrompt;
    //   // 调用 callback 返回建议列表的数据
    //   cb(results);
    // },
    // querySearchShop(queryString, cb) {
    //   let results = queryString
    //     ? this.shopListForPrompt.filter(this.$createFilter(queryString))
    //     : this.shopListForPrompt;
    //   cb(results);
    // }
  },

  async mounted() {
    setTimeout(() => {
      this.onSubmit();
    }, 1000);
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-select {
  width: 202px;
}
.sp1 {
  font-weight: bold;
  padding: 5px 0px;
}
.sp2 {
  color: red;
  font-weight: bold;
  padding: 5px 20px 5px 0px;
}
</style>
